<template>
    <div class="main-container">
        <div class="w">
            <div class="order-pay-result">
                <div class="title">
                    <i class="el-icon-circle-check"></i>
                    <h4>您的订单已支付</h4>
                </div>
                <p class="payment">
                    支付结果可能会有延时，详情请到<span @click="enterPersonal"
                        >个人中心</span
                    >——<span @click="enterMineOder">我的订单</span>里查看订单状态！
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "result",
    data() {
        return {};
    },
    methods: {
        enterPersonal() {
            this.$router.push("/pcViews/personal/information");
        },
        enterMineOder() {
            this.$router.push("/pcViews/personal/order");
        },
    },
};
</script>
<style  scoped lang="less">
.payment span {
    color: #b21f27;
    font-weight: bold;
    cursor: pointer;
}
.payment {
    margin-top: 60px;
    font-size: 16px;
    color: #606266;
    line-height: 32px;
}
.order-pay-result{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    background: #fff;
    >.title{
        display: flex;
        flex-direction: row;
        font-size: 25px;
        color: #252b3a;
        margin-bottom: 13px;
        >i{
            font-size: 30px;
            color: #b21f27;
            margin-right: 14px;
        }
    }
}
</style>>
